import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateShort(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}

export function getDaysBetween(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffTime = Math.abs(endDate - startDate);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result.toISOString().split('T')[0];
}

export function getDateRange(tasks) {
  if (!tasks.length) {
    const today = new Date();
    return {
      start: today.toISOString().split('T')[0],
      end: addDays(today, 30),
    };
  }

  const dates = tasks.flatMap(t => [new Date(t.start_date), new Date(t.end_date)]);
  const minDate = new Date(Math.min(...dates));
  const maxDate = new Date(Math.max(...dates));
  
  // Add padding
  minDate.setDate(minDate.getDate() - 2);
  maxDate.setDate(maxDate.getDate() + 2);

  return {
    start: minDate.toISOString().split('T')[0],
    end: maxDate.toISOString().split('T')[0],
  };
}

export function generateDateArray(start, end) {
  const dates = [];
  const current = new Date(start);
  const endDate = new Date(end);

  while (current <= endDate) {
    dates.push(new Date(current).toISOString().split('T')[0]);
    current.setDate(current.getDate() + 1);
  }

  return dates;
}

export function getProgressColor(progress) {
  if (progress >= 100) return 'bg-status-success';
  if (progress >= 50) return 'bg-status-info';
  if (progress > 0) return 'bg-status-warning';
  return 'bg-zinc-300';
}

export function exportToExcel(data, filename) {
  import('xlsx').then((XLSX) => {
    const wb = XLSX.utils.book_new();
    
    // Tasks sheet
    if (data.tasks?.length) {
      const tasksWs = XLSX.utils.json_to_sheet(data.tasks);
      XLSX.utils.book_append_sheet(wb, tasksWs, 'Tasks');
    }
    
    // Milestones sheet
    if (data.milestones?.length) {
      const milestonesWs = XLSX.utils.json_to_sheet(data.milestones);
      XLSX.utils.book_append_sheet(wb, milestonesWs, 'Milestones');
    }
    
    // Project info sheet
    if (data.project) {
      const projectWs = XLSX.utils.json_to_sheet([data.project]);
      XLSX.utils.book_append_sheet(wb, projectWs, 'Project Info');
    }
    
    XLSX.writeFile(wb, `${filename}.xlsx`);
  });
}
